export default {
  "pages:home:menuLabel": "Home",
  "pages:company:menuLabel": "Azienda",
  "pages:products:menuLabel": "Prodotti",
  "pages:services:menuLabel": "Servizi",
  "pages:projects:menuLabel": "Progetti",
  "pages:procurement:menuLabel": "Attività",
  "pages:quality:menuLabel": "Qualità",
  "pages:news:menuLabel": "News",
  "pages:contacts:menuLabel": "Contatti",

  "pages:home:title": "Putting ART in Technology",
  "pages:home:news-title": "NEWS",
  "pages:home:news-sub-title": "NUOVA APERTURA",
  "pages:home:news-content": "Divisione Energie Rinnovabili",
  "pages:home:news-content-2": "Lampade Solari a LED",

  "pages:company:title": "Azienda",
  "pages:company:description":
    "<p class='company-text-1'>A.R.Technology svolge attività commerciali, ingegneristiche ed energetiche a livello internazionale ed è leader nella fornitura di prodotti destinati alle società Oil & Gas, Energy, Upstream, Midstream e Downstream, secondo i più recenti requisiti di qualità e nel rispetto delle norme internazionali. È specializzata nella fornitura di pacchetti di materiale sfuso (tubi, valvole, componenti meccanici, strumentazione, materiale elettrico) in cui la qualità ed i tempi di consegna sono essenziali per tutti quei progetti che richiedono materiali di diverso genere in una unica soluzione.</p><p style='text-align: right'><a href='documents/brochure.pdf' download><b>Download Brochure</b></a></p>",

  "pages:products:title": "Prodotti",
  "pages:products:description": `
    <div class="product-category">
      <h2>Piping Bulk Material</h2>
      <img src='images/products/Piping_Bulk_Material.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Stud Bolts</div>
        <div class="product">Gasket</div>
        <div class="product">Pipes</div>
        <div class="product">Fittings</div>
        <div class="product">Flanges</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Pressure and Temperature Measurements</h2>
      <img src='images/products/Pressure_Measurements.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Differential Pressure Transmitter</div>
        <div class="product">Pressure Indicators</div>
        <div class="product">Differential Pressure Indicators</div>
        <div class="product">Temperature transmitters</div>
        <div class="product">Temperature indicators</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Manual Valves</h2>
      <img src='images/products/Manual_Valves.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Ball Valves</div>
        <div class="product">Globe Valves</div>
        <div class="product">Gate Valves</div>
        <div class="product">Check Valves</div>
        <div class="product">Butterfly Valves</div>
      </div>
    </div><!--
    --><div class="product-category">
      <h2>Flow & Level Measurements</h2>
      <img src='images/products/Flow_&_Level_Measurements.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Multiphase Flowmeters</div>
        <div class="product">Ultrasonic Flowmeters</div>
        <div class="product">Level Transmitter</div>
        <div class="product">Level Indicators</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Skid Mounted Packages</h2>
      <img src='images/products/Skid_Mounted_Packages.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Cooling Skid</div>
        <div class="product">Sampling Panels</div>
        <div class="product">LPG Basket Filter Package</div>
        <div class="product">Interpiping Skid</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Instruments Bulk Material</h2>
      <img src='images/products/Instruments_Bulk_Material.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Manifold Instruments Valves</div>
        <div class="product">Compression Fittings</div>
        <div class="product">Seamless Tubing</div>
      </div>
    </div>
  `,

  "pages:engineering:title": "Engineering",
  "pages:engineering:description": `
    <b>A.R.Technology offre servizi di ingegneria tra cui:</b>
    <ul>
      <li>Sopralluoghi</li>
      <li>Studi di fattibilità</li>
      <li>Progettazione ingegneristica di base e dettagliata</li>
      <li>Architettura del sistema di progettazione</li>
      <li>FAT & SAT</li>
      <li>Messa in servizio e avvio</li>
      <li>Assistenza post vendita</li>
      <li>Applicazioni Chiavi in Mano</li>
      <li>Ingegneria di manutenzione</li>
      <li>Reclutamento e fornitura di personale tecnico</li>
      <li>Corsi di formazione personalizzati</li>
    <ul>
  `,

  "pages:procurement:title": "Procurement",
  "pages:procurement:description": `
    <b>A.R.Technology offre Attività di Procurement & Project Management:</b>
    <ul>
      <li>Approvvigionamenti</li>
      <li>Forniture rapide dove il tempo di consegna è essenziale</li>
      <li>Forniture di parti di ricambio e secondo marchio e origine richiesti dal Cliente</li>
      <li>Forniture speciali in conformità con le specifiche del cliente, tra cui rivestimento e verniciatura</li>
      <li>Manutenzione</li>
      <li>Negoziazione dei contratti di servizio</li>
      <li>Ricerche di mercato su produttori e fornitori</li>
      <li>Servizio post-ordine e ispezione, sia interna che esterna di terze parti</li>
      <li>Spedizioni nazionali ed internazionali</li>
    </ul>
  `,

  "pages:quality:title": "Qualità",
  "pages:quality:description": `
		<p class="qualita-text-1">A.R.Technology si impegna ad effettuare un costante controllo di qualità per garantire il miglior servizio possibile ed offrire ai propri clienti prodotti in assoluta conformità ai requisiti e standard mondiali. La qualità è parte integrante dei principi aziendali aziendali A.R.Technology ed ispira le nostre azioni per fornire prodotti e servizi sicuri. Riteniamo infatti che la affidabilità di un fornitore sia un fattore determinante per consentire lo sviluppo dell’azienda.</p>
    <p  style="text-align:right">
      <a href="documents/45001_IT.pdf" download><b>Certificato ISO 45001 |</b></a>
      <a href="documents/ISO_code_IT.pdf" download><b>Certificato ISO 9001 <span class='hide-mobile'>|</span></b></a><br class='show-mobile' />
      <a href="documents/politica_aziendale.pdf" download><b>Politica aziendale |</b></a>
			<a href="documents/ethical_code.pdf" download><b>Codice Etico</b></a>
    </p>
  `,

  "pages:news:title": "News",
  "pages:news:description": `<p class="news-text-1">A.R.Technology è orgogliosa di annunciare l’apertura della sua nuova sede ad Atyrau, Kazakhstan. La nuova sede sarà operativa a partire dal 4 gennaio 2018. Seguiranno maggiori dettagli.</p>`,

  "projects:VE1:name":
    "<p>Project: PERLA<br>Contractor:  NAPEA INTERNATIONAL INC<br>Final Client:  CARDON IV<br>Destination:  VENEZUELA<br>Scope of supply:  SUPPLY OF PIPE MATERIAL</p>",
  "projects:VE2:name":
    "<p>Project: PERLA<br>Contractor:  CARDON IV<br>Final Client:  CARDON IV<br>Destination:  VENEZUELA<br>Scope of supply:  MATERIAL FOR FLOWLINES</p>",
  "projects:IT:name":
    "<p>Project: N/A<br>Contractor:  SAIPEM SPA<br>Final Client:  SAIPEM SPA<br>Destination:  ITALY<br>Scope of supply:  PROCUREMENT SERVICES</p>",
  "projects:KZ1:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM<br>ESKENE WEST RAIL PROJECT<br>Contractor:  EUSEBI IMPIANTI SRL<br>Final Client:  NCOC (Ex AGIP KCO)<br>Destination:  KAZAKHSTAN<br>Scope of supply:  INSTRUMENTAL BULK & SAMPLING SKIDS</p>",
  "projects:KZ2:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM<br>ESKENE WEST RAIL PROJECT<br>Contractor:  BERTRAMS HEATEC AG<br>Final Client:  NCOC (Ex AGIP KCO)<br>Destination:  KAZAKHSTAN<br>Scope of supply:  VALVES</p>",
  "projects:KZ3:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: ISKER CONSORTIUM LLP<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: INSTRUMENTAL BULK & CABLE TRAYS</p>",
  "projects:KZ4:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: KELBURN ENGINEERING LTD<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: VALVES</p>",
  "projects:KZ5:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: PSN KAZSTROY JSC<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: INSTRUMENTAL, ELECTRICAL AND F&G MATERIAL</p>",
  "projects:KZ6:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: PSN KAZSTROY JSC<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: HEAT EXCHANGER GASKETS</p>",
  "projects:KZ7:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: WORLEYPARSONS LTD<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: GASKETS, BOLTS & SPARES</p>",
  "projects:KZ8:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: SEASTAR INTERNATIONAL<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: BOLTS, NUTS, SCREW, WASHER</p>",
  "projects:KZ9:name": "<p>NUOVA APERTURA ATYRAU!</p>",
  "projects:DZ1:name":
    "<p>Project: ON SHORE LEDJMET BLOCK 405b CAF C GAS GATHERING<br>Contractor:  SH FCP - SONATRACH<br>Final Client:  SH FCP - SONATRACH<br>Destination:  ALGERIA<br>Scope of supply:  FIELD INSTRUMENTS & PIPING BULK MATERIALS</p>",
  "projects:DZ2:name":
    "<p>Project: CHAMPS BRN&ROD BLOCKS 401A & 402A<br>Contractor:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Final Client:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Destination:  ALGERIA<br>Scope of supply:  VALVES & PIPING BULK MATERIAL</p>",
  "projects:DZ3:name":
    "<p>Project: MACARONI STRINGS REINTEGRATION PROGRAM<br>Contractor:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Final Client:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Destination:  ALGERIA<br>Scope of supply:  MACARONI STRINGS</p>",
  "projects:EG1:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  EFW AND SEAMLESS PIPES</p>",
  "projects:EG2:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  FITTINGS AND PIPING</p>",
  "projects:EG3:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  INSTRUMENTATION AND ELECTRICAL MATERIAL</p>",
  "projects:EG4:name":
    "<p>Project: ZOHR<br>Contractor:  PETROJET<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  PIG TRAPS</p>",
  "projects:EG5:name":
    "<p>Project: NIDOCO NORTH WEST GAS DEVELOPMENT PROJECT<br>Contractor:  PETROBEL BELAYM PRETROLEUM - ENI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  SUPPLY OF FLANGES</p>",
  "projects:EG6:name":
    "<p>Project: VARIOUS<br>Contractor:  BAPETCO (BADR PETROLEUM COMPANY)<br>Final Client:  SHELL<br>Destination:  EGYPT<br>Scope of supply:  INSTRUMENTS & BULK MATERIALS</p>",
  "projects:EG7:name":
    "<p>Project: UGDC LNG PLANT PORT SAID IMPROVEMENT<br>Contractor:  UNITED GAS AND DERIVATES (UGDC)<br>Final Client:  ENI – BP - GASCO<br>Destination:  EGYPT<br>Scope of supply:  VALVES</p>",
  "projects:CD1:name":
    "<p>Project: VARIOUS PLATFORMS<br>Contractor:  NUOVA O.M.A.<br>Final Client:  ENI CONGO<br>Destination:  CONGO<br>Scope of supply:  PIPING BULK MATERIAL & VALVES</p>",
  "projects:CD2:name":
    "<p>Project: C23932 ENI CONGO KITINA & AEP<br>Contractor:  SAIPEM<br>Final Client:  ENI CONGO<br>Destination:  CONGO<br>Scope of supply:  FIELD INSTRUMENTS</p>",
  "projects:TN1:name":
    "<p>Project: MAAMOURA & BARAKA<br>Contractor:  ENI TUNISIA B.V.<br>Final Client:  ENI TUNISIA B.V.<br>Destination:  TUNISIA<br>Scope of supply:  FIELD INSTRUMENTS</p>",
  "projects:TN2:name":
    "<p>Project: BIR BEN TARTAR EPF<br>Contractor:  MEDCO ENERGI INTERNATIONAL<br>Final Client:  MEDCO ENERGI INTERNATIONAL<br>Destination:  TUNISIA<br>Scope of supply:  PIPING BULK MATERIAL</p>",

  "pages:contacts:title": "Contatti",
  "pages:contacts:description": `
    <p>
      Via Angelo Moro 119, 20097<br />
      S.Donato M.se, Italia<br />
      P.IVA: IT 08817750154
    </p>
    <p>
      Email: artechno@artechno.it
      <br />
      Tel: +39 02 5578271
      <br />
      Fax: +39 02 55782719
      <br />
    </p>
    <p>
      <a href="documents/Informativa_Privacy_GDPR_it.pdf" style="text-transform:none" download>Informativa al trattamento dei dati personali ai sensi del regolamento Europeo 679/2016 (GDPR)</a>
    </p>
  `,

  "pages:new-energy:title": "Divisione Energie Rinnovabili",
  "pages:new-energy:description":
    "Dal 2018 la A.R.Technology S.r.l. ha deciso di ampliare il proprio Core Business, specializzandosi anche nella progettazione, fornitura e realizzazione di Impianti per la Produzione Energia Elettrica da Fonti Rinnovabili, in Italia e all’Estero.<br /><br />La ART, avvalendosi di importanti collaborazioni e di un team di tecnici specializzati, è in grado di realizzare Impianti Fotovoltaici, Impianti di Cogenerazione a Biomassa, Rifiuti e Biogas/Biometano. ART, inoltre, sta investendo importanti risorse nello sviluppo del binomio Agricoltura/Energia ed è in grado di fornire sistemi integrati di serre con centrali termiche ed elettriche.<br />Tutti i tipi di impianti possono essere forniti chiavi in mano, comprendendo sia la parte progettuale/ operativa, nonché l'assistenza post-vendita.<br /><br />Tutti gli impianti prodotti rispondono ai più elevati standard qualitativi, alle normative vigenti e sono in possesso di tutte le certificazioni richieste.",

  "pages:new-partnership:title": "New Partnership with Solar Lighting International",
  "pages:new-partnership:description": `STEALTH 120-21 LED SOLAR STREET LIGHT <br><br> 
    <span style='font-weight: bold; margin-top: 10px;';>Features & Advantages</span> 
    <ul style='margin-top: 10px;'>
      <li>- Replaceable Parts - <span style='font-weight: bold';>Replaceable Battery | Replaceable Light Bar</span> </li>
      <li>- Unique Patented Design</li>
      <li>- Patented smart working modes for longer lighting time</li>
      <li>- Remote control add-on makes changing the work modes effortless</li>
      <li>- Professional light distribution optical lens for a wide lighting area</li>
      <li>- High Quality Mono-crystalline Solar Panel</li>
      <li>- LED light bars are adjustable to 40°</li>
      <li>- Wide angle detection enables body movement in a larger area and a longer distance</li>
    </ul>
    
    <br><br>
    <a style="padding: 0.8em 1.5em;
    background-color: white;
    border-radius: 32px;
    border: 2px solid #009119;
    color: #009119;
    display: inline-block;
    margin-left: 4em;
    vertical-align: middle;
    font-size: 15px;
    font-weight: 600;" href='documents/SLI-STEALTH-LED-Solar-street-light.pdf' download><b>Download Product's PDF</b></a>
  `,    

  "app:language:it": "it",
  "app:language:en": "en",
  "app:language:ru": "ru",
};



// WEBPACK FOOTER //
// ./src/dictionaries/it.js